import { ITEM_STATUS_AWAITING_DATES, ITEM_STATUS_CANCELLED } from 'constants/cart'
import { ExperienceBookingType } from 'constants/experience'
import { isStandaloneExperience } from './orderExperienceClassification'

export function getExperienceItemsNeedingRedemption(order: App.Order): Array<App.OrderExperienceItem> {
  if (order.experienceItems.some(item => item.status === ITEM_STATUS_AWAITING_DATES || !isStandaloneExperience(item, order))) {
    return []
  }

  return order.experienceItems.filter(item => item.status !== ITEM_STATUS_CANCELLED &&
    (!item.date || item.bookingType === ExperienceBookingType.BUY_NOW_BOOK_LATER))
}

export function canMarkExperienceOrderAsRedeemed(order: App.Order, bookingDetails: Record<string, App.ExperienceBookingDetails>): boolean {
  const items = getExperienceItemsNeedingRedemption(order)
  return items.length > 0 && items.every(item => !!bookingDetails[item.id]) &&
    items.some(item => !bookingDetails[item.id].markedAsRedeemed)
}
